import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  SelectChangeEvent,
} from '@mui/material'
import { useField } from 'formik'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { DetailEditorPropsByYear } from '../types'

export const BiomassBurningInputEditorSimple = ({
  name = 'biomassBurning',
}: Pick<DetailEditorPropsByYear, 'name'>) => {
  const { t } = useTranslation('@cibo/landmanager/BiomassBurningEditor')
  // eslint-disable-next-line no-empty-pattern
  const [{}, {}, { setTouched }] = useField(name)
  // eslint-disable-next-line no-empty-pattern
  const [{ value }, {}, { setValue }] = useField(`${name}.hadBiomassBurning`)
  const [hadBiomassBurning, setHadBiomassBurning] = useState<boolean | ''>(
    value === undefined ? '' : value
  )

  useEffect(() => {
    if (typeof value === 'undefined') {
      setHadBiomassBurning('')
    } else {
      setHadBiomassBurning(value)
    }
  }, [value])

  const handleHadBiomassBurningChange = ({ target: { value } }: SelectChangeEvent) => {
    const persistValue = value === 'yes' ? true : value === 'no' ? false : undefined
    setHadBiomassBurning(persistValue === undefined ? '' : persistValue)
    setValue(persistValue)
    setTouched(true, false)
  }

  return (
    <FormControl data-testid="biomass-had-biomass-burning" required>
      <FormLabel>{t('didYouBurn')}</FormLabel>

      <RadioGroup
        id={`${name}.hadBiomassBurning`}
        value={hadBiomassBurning === true ? 'yes' : hadBiomassBurning === false ? 'no' : ''}
        onChange={handleHadBiomassBurningChange}
        row
      >
        <FormControlLabel
          value="yes"
          control={<Radio />}
          label={t('yes')}
          data-testid={`${name}.hadBiomassBurning-yes`}
        />
        <FormControlLabel value="no" control={<Radio />} label={t('no')} />
      </RadioGroup>
    </FormControl>
  )
}
